module.exports = __webpack_public_path__ + "static/typescript_icon-6d2121b2f23d951b563aae3e273f90c4.png";